import resume from '../assets/pdf/Abdelrahman-resume.pdf'
import id from '../assets/jpg/id.jpg'

export const headerData = {
    name: 'Abdelrahman Hasan',
    title: "Front-End Developer",
    desciption: "Passionate about combining the art of design with the art of programming.",
    image: id,
    resumePdf: resume
}
